import React from 'react';

export default function Header({ title, user, onLogout }) {
  const initials = user?.name
    ? user.name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2)
    : 'U';

  return (
    <header className="header no-print">
      <span className="header-title">{title}</span>
      <div className="header-right">
        <div className="header-user">
          <div className="avatar">{initials}</div>
          <div>
            <div className="name">{user?.name || 'User'}</div>
            <div className="role">{user?.role || 'staff'}</div>
          </div>
        </div>
        <button className="btn btn-ghost btn-sm" onClick={onLogout}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ width: 14, height: 14 }}>
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
          Logout
        </button>
      </div>
    </header>
  );
}
